import { RouteConfig } from 'vue-router'
import lazyImporter from '@/utils/lazyImporter'

const getContentPath = (needsPageSlug: boolean = false) => {
  const prefix = needsPageSlug ? ':slug/' : ''

  return `${prefix}content`
}

const pageContentRoutes = (pageContext: string, needsPageSlug: boolean = false): RouteConfig[] => ([
  {
    component: lazyImporter('page/PageContentAdd'),
    name: `admin_${pageContext}_content_add`,
    path: `${getContentPath(needsPageSlug)}/add`,
    props: (route) => ({ pageContext, ownerSlug: route.params.slug })
  },
  {
    component: lazyImporter('page/PageContentList'),
    name: `admin_${pageContext}_content_list`,
    path: `${getContentPath(needsPageSlug)}`,
    props: (route) => ({ pageContext, ownerSlug: route.params.slug })
  },
  {
    component: lazyImporter('page/PageContentUpdate'),
    name: `admin_${pageContext}_content_update`,
    path: `${getContentPath(needsPageSlug)}/:contentSlug/update`,
    props: (route) => ({ pageContext, ownerSlug: route.params.slug, slug: route.params.contentSlug })
  }
])

const pageRoute: RouteConfig = {
  component: lazyImporter('View'),
  meta: { title: 'pages', icon: 'bookmarks' },
  name: 'admin_pages',
  path: '/page',
  redirect: { name: 'admin_page_list' },
  children: [
    {
      component: lazyImporter('page/PageList'),
      meta: { title: 'pageList', hidden: true },
      name: 'admin_page_list',
      path: ''
    },
    {
      component: lazyImporter('page/draft/PageDraftList'),
      meta: { title: 'draftList', hidden: true },
      name: 'admin_page_draft_list',
      path: 'draft'
    },
    {
      component: lazyImporter('page/PageAdd'),
      meta: { title: 'pageAdd', hidden: true },
      name: 'admin_page_add',
      path: 'add',
      redirect: { name: 'admin_page_add_details' },
      children: [
        ...pageContentRoutes('page_add', true),
        {
          component: lazyImporter('page/add/PageAddDetails'),
          name: 'admin_page_add_details',
          path: 'details'
        },
        {
          component: lazyImporter('page/PageValidate'),
          name: 'admin_page_add_validate',
          path: ':slug/validate',
          props: true
        }
      ]
    },
    {
      component: lazyImporter('page/PageUpdate'),
      meta: { title: 'pageUpdate', hidden: true },
      name: 'admin_page_update',
      path: ':slug/update',
      props: true,
      redirect: (to) => {
        const { params } = to

        if (params.slug) {
          return `/page/${params.slug}/update/details`
        }

        return { name: 'admin_page_list' }
      },
      children: [
        ...pageContentRoutes('page_update'),
        {
          component: lazyImporter('page/update/PageUpdateDetails'),
          name: 'admin_page_update_details',
          path: 'details',
          props: true
        }
      ]
    },
    {
      component: lazyImporter('page/draft/PageDraftUpdate'),
      meta: { title: 'pageDraftUpdate', hidden: true },
      name: 'admin_page_draft_update',
      path: 'draft/:slug/update',
      props: true,
      redirect: (to) => {
        const { params } = to

        if (params.slug) {
          return `/page/draft/${params.slug}/update/details`
        }

        return { name: 'admin_page_list' }
      },
      children: [
        ...pageContentRoutes('page_draft_update'),
        {
          component: lazyImporter('page/update/PageUpdateDetails'),
          name: 'admin_page_draft_update_details',
          path: 'details',
          props: (route) => {
            return { slug: route.params.slug, isDraft: true }
          }
        },
        {
          component: lazyImporter('page/PageValidate'),
          name: 'admin_page_draft_update_validate',
          path: 'validate',
          props: true
        }
      ]
    }
  ]
}

export default pageRoute
